import React from 'react';
import { motion } from 'framer-motion';
import { PsychologyTags } from './PsychologyTags';
interface SlideContainerProps {
  sectionTag: string;
  backgroundColor?: string;
  children: ReactNode;
  psychologyTags?: string[];
  className?: string;
}
export function SlideContainer({
  sectionTag,
  backgroundColor = 'bg-white',
  children,
  psychologyTags,
  className = ''
}: SlideContainerProps) {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6
  }} className={`min-h-screen flex flex-col justify-center ${backgroundColor} ${className}`} data-id="element-111">
      <div className="max-w-md mx-auto w-full px-6 py-12" data-id="element-112">
        <div className="mb-6" data-id="element-113">
          <span className="inline-block px-3 py-1 text-xs font-bold uppercase tracking-wider text-teal-600 bg-teal-50 rounded-full" data-id="element-114">
            {sectionTag}
          </span>
        </div>

        <div className="space-y-6" data-id="element-115">{children}</div>

        {psychologyTags && <PsychologyTags tags={psychologyTags} data-id="element-116" />}
      </div>
    </motion.section>;
}